module.exports = __webpack_public_path__ + "img/facturacion.73071409.svg";